<template>
  <div
    ref="frame"
    class="focuspoint">
    <img :src="imageUri" :style="adjustFocus"/>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    imageUri: {
      default: '#',
      type: String,
    },
    focusX: Number,
    focusY: Number,
    imageW: Number,
    imageH: Number,
  },
  data: () => ({
    containerW: Number,
    containerH: Number,
  }),
  mounted() {
    this.updateContainerSize();
  },
  created() {
    window.addEventListener('resize', this.updateContainerSize);
  },
  unmounted() {
    window.removeEventListener('resize', this.updateContainerSize);
  },
  computed: {
    /* Code from jQuery FocusPoint; version: 1.1.3 */
    // Re-adjust the focus
    adjustFocus() {
      const {
        containerW,
        containerH,
        focusX,
        focusY,
        imageW,
        imageH,
      } = this;

      if (!(containerW > 0 && containerH > 0 && imageW > 0 && imageH > 0)) {
        return false; // Need dimensions to proceed
      }

      // Which is over by more?
      const wR = imageW / containerW;
      const hR = imageH / containerH;

      // Amount position will be shifted
      const hShift = this.calcShift(hR, containerW, imageW, focusX);
      const vShift = this.calcShift(wR, containerH, imageH, focusY, true);

      return {
        top: vShift,
        left: hShift,
        maxWidth: (wR > hR) ? '' : '100%',
        maxHeight: (wR > hR) ? '100%' : '',
      };
    },
  },
  methods: {
    /* Code from jQuery FocusPoint; version: 1.1.3 */
    // Calculate the new left/top values of an image
    calcShift(conToImageRatio, containerSize, imageSize, focusSize, toMinus) {
      const containerCenter = Math.floor(containerSize / 2); // Container center in px
      const focusFactor = (focusSize + 1) / 2; // Focus point of resize image in px
      const scaledImage = Math.floor(imageSize / conToImageRatio); // Can't use width() as images may be display:none
      let focus = Math.floor(focusFactor * scaledImage);
      if (toMinus) focus = scaledImage - focus;
      let focusOffset = focus - containerCenter; // Calculate difference between focus point and center
      const remainder = scaledImage - focus; // Reduce offset if necessary so image remains filled
      const containerRemainder = containerSize - containerCenter;
      if (remainder < containerRemainder) focusOffset -= containerRemainder - remainder;
      if (focusOffset < 0) focusOffset = 0;

      const offsetPercentage = (focusOffset * -100) / containerSize;
      return `${offsetPercentage}%`;
    },
    updateContainerSize() {
      this.containerW = this.$refs.frame.clientWidth;
      this.containerH = this.$refs.frame.clientHeight;
    },
  },
});
</script>

<style scoped lang='scss'>
.focuspoint {
  overflow: hidden;
  background: #efefef;
  float: left;
  position: relative;
}
.focuspoint img {
  margin: 0;
  display: block;
  /* fill and maintain aspect ratio */
  width: auto; height: auto;
  min-width: 100%; min-height: 100%;
  max-height: none; max-width: none;

  position: absolute;
  top: 0;
  left: 0;
  transition: all .5s ease-in-out;
}
</style>
